import React, { useEffect, useState } from "react";
import { apiHelper } from "../../lib/ApiHelper";
import { AgGridReact } from "@ag-grid-community/react";
import "../MainBox.css";
import PRHLoader from "../../lib/PRHLoader";
export default function ComponentsOnHandUS(props) {

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }
    const [isLoading, setIsLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [coralRowData, setCoralRowData] = useState([]);
    const gridOptions = {
        defaultColDef: {
            resizable: true,
            sortable: true,
        },
        animateRows: true,
        accentedSort: true,
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        autoGroupColumnDef: { minWidth: 50 },
        overlayNoRowsTemplate: '<span></span>',
        rowSelection: 'multiple',
        // onGridReady: (event) => event.api.sizeColumnsToFit(),
    }

    const columnDefs = [
        { headerName: "Component Type", field: "componentType", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100 },
        {
            headerName: "Qty on Hand", field: "quantityOnHand", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-right",
            cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
        { headerName: "Binder", field: "binder", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 70 },
        {
            headerName: "US Price", field: "usPrice", headerClass: "HeaderClassSource header-text-right" , cellClass: "CellClassSource  cell-text-right", width: 70,
            valueFormatter: params => {
                if (params.value) {
                    return params.value.toFixed(2);
                }
            }
        },
        {
            headerName: "CA Price", field: "caPrice", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource  cell-text-right", width: 70,
            valueFormatter: params => {
                if (params.value) {
                    return params.value.toFixed(2);
                }
            }
        },
        {
            headerName: "Received", field: "receivedDate", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;
            }, width: 100
        },
        {
            headerName: "Scrap Suggestion", field: "scrapSuggestion", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 130
        },
        {
            headerName: "Report Date", field: "reportDate", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;
            }, width: 80
        },
    ];
    const coralColumnDefs = [
        { headerName: "Component Type", field: "componentType", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-left", width: 120 },
        {
            headerName: "Ordered Qty", field: "orderedQty", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-right",
            cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 80
        },
        { headerName: "Ship To", field: "shipTo", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 150 },
        {
            headerName: "Prod Order #", field: "prodOrder", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-right", width: 100
        },
        {
            headerName: "Req Due", field: "reqDue", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 80
        },
        {
            headerName: "Est Ship", field: "estShip", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 80
        },
    ];

    function formatNumberWithCommas(number) {
        if (isNaN(number)) {
            return '';
        }
        // Convert number to string
        let str = number.toString();

        // Split the number into integer and decimal parts
        let parts = str.split(".");

        // Format integer part with commas
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // If decimal part exists and has one digit, add a trailing zero
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }

        // Join integer and decimal parts and return
        return parts.join(".");
    }

    const fetchData = async (id) => {
        try {
            if (id) {
                setIsLoading(true);
                const data = await apiHelper.inventoryPostCall("getCompHand", { value: id });
                if (data != undefined && data != null) {
                    setRowData(data);
                }
                const coralData = await apiHelper.inventoryPostCall("getCompHandCoralData", { value: id });
                if (coralData != undefined && coralData != null) {
                    setCoralRowData(coralData);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }


    useEffect(() => {

            if (props.ISBNId) {
                fetchData(props.ISBNId);
            }
        
    }, [props.metaData]);

    return (<>
        {isLoading && <PRHLoader></PRHLoader>}
        {rowData.length > 0 ?
            <div className="agGridContainer title-data padding-top-10 custom" style={{ height: "100%", width: "100%", overflowY: "auto", maxHeight: "300px", paddingLeft: "20px", marginBottom: "10px" }}>
                <p className="ml-0 mb-0">Components On Hand</p>
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    domLayout="autoHeight"
                    gridOptions={gridOptions}
                ></AgGridReact>
            </div>
            :
            <></>}
        {coralRowData.length > 0
            ?
            <div className="agGridContainer title-data custom" style={{ height: "100%", width: "100%", overflowY: "auto", maxHeight: "300px", paddingLeft: "20px", marginTop: "30px", marginBottom: "10px" }}>
                <p className="ml-0 mb-0">Coral Components</p>
                <AgGridReact
                    rowData={coralRowData}
                    columnDefs={coralColumnDefs}
                    domLayout="autoHeight"
                    gridOptions={gridOptions}
                ></AgGridReact>
            </div>
            :
            <></>}
    </>)
}